// src/views/ProcesosBatch/ImportarArchivoSap/ImportarArchivoSap.jsx
import React from "react";
import EjecutarProceso from "../../EstadosFlujos/Procesos/EjecutarProceso";

export default function ImportarArchivoSap() {
  return (
    <EjecutarProceso
      procesoId={10}
      titulo="Importar archivos SAP"
      showSuccess={true}   // 👈 muestra notify SUCCESS con la salida del batch
    />
  );
}
